"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SuggestionHeader_1 = require("./SuggestionHeader");
Object.defineProperty(exports, "SuggestionHeader", { enumerable: true, get: function () { return SuggestionHeader_1.SuggestionHeader; } });
//# sourceMappingURL=index.js.map